export default __webpack_public_path__ + "static/media/lumpsum.ec733a41.svg";